export type SpaceDrawMode = 'select' | 'draw';

export function resolveActiveSpaceDrawMode(
  isAddSpacesStep: boolean,
  spaceDrawMode: SpaceDrawMode
): SpaceDrawMode | undefined {
  return isAddSpacesStep ? spaceDrawMode : undefined;
}

export function isSpaceDrawingActive(
  isAddSpacesStep: boolean,
  spaceDrawMode: SpaceDrawMode
): boolean {
  return resolveActiveSpaceDrawMode(isAddSpacesStep, spaceDrawMode) === 'draw';
}
